module.exports = __webpack_public_path__ + "img/w2.b58da975.jpg";